import Icon from '@components/Icon';
import { Trans } from '@lingui/react';
import VideoSettings from '@ecosystems/VideoSettings';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;

  flex: 1;

  border-radius: 4px;
  background-color: #e5f4fe;

  @media (max-width: ${props => `${props.theme.viewports.tablet}px`}) {
    flex-direction: column;
  }
`;

const Text = styled.p`
  margin: 0;
  font-size: 14px;
  color: #3c3c3c;
  @media (min-width: ${props => `${props.theme.viewports.tablet + 1}px`}) {
    margin-right: 20px;
  }
  @media (max-width: ${props => `${props.theme.viewports.tablet}px`}) {
    margin-bottom: 20px;
  }
`;

const VideoSettingsBanner = () => {
  return (
    <Wrapper>
      <Text>
        <Icon
          name="ygb-icon-infob"
          fontSize="14px"
          color={'#96a0a4'}
          mr={'10px'}
        />
        <Trans
          id="video_settings_banner.info"
          message={
            'Customize your Yogobe experience by changing the video settings. This feature helps you narrow down your possible results.'
          }
        />
      </Text>
      <VideoSettings />
    </Wrapper>
  );
};

export default VideoSettingsBanner;
